export default "__VITE_ASSET__CvE0kcCB__"